import { render, staticRenderFns } from "./promocion-prevencion.vue?vue&type=template&id=7850d2cc&scoped=true&"
import script from "./promocion-prevencion.vue?vue&type=script&lang=js&"
export * from "./promocion-prevencion.vue?vue&type=script&lang=js&"
import style0 from "./promocion-prevencion.vue?vue&type=style&index=0&id=7850d2cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7850d2cc",
  null
  
)

export default component.exports